import { render, staticRenderFns } from "./globalStats.vue?vue&type=template&id=4ecf34b0"
import script from "./globalStats.vue?vue&type=script&setup=true&lang=js"
export * from "./globalStats.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports